import _definePage_default_0 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/[...path].vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/admin-panel/people.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/admin-panel.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/auth/login.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/cookie-policy.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/index.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/beat-the-clock.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/classic-game.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/leaderboard.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/settings.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/weakest-link/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/index.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/beat-the-clock.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/classic-game.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/leaderboard.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/settings.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/weakest-link/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/index.vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/beat-the-clock.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/classic-game.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/leaderboard.vue?definePage&vue&lang.tsx'
import _definePage_default_23 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/settings.vue?definePage&vue&lang.tsx'
import _definePage_default_24 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/weakest-link/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_25 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/privacy-policy.vue?definePage&vue&lang.tsx'
import _definePage_default_26 from '/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/terms-of-use.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'HomePage',
    component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:path(.*)',
    name: 'CatchAllPage',
    component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/[...path].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/admin-panel',
    name: 'AdminPanel',
    component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/admin-panel.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: 'people',
        name: 'AdminPanelPeople',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/admin-panel/people.vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  _definePage_default_4
  ),
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/auth.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'LoginPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/auth/login.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/cookie-policy',
    name: 'CookiePolicyPage',
    component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/cookie-policy.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  {
    path: '/movies',
    /* internal name: '/movies' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'MoviesPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/index.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'beat-the-clock',
        name: 'MoviesBeatTheClockPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/beat-the-clock.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: 'classic-game',
        name: 'MoviesClassicGamePage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/classic-game.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: 'leaderboard',
        name: 'MoviesLeaderboard',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/leaderboard.vue'),
        /* no children */
      },
  _definePage_default_10
  ),
  _mergeRouteRecord(
      {
        path: 'settings',
        name: 'MoviesSettingsPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/settings.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
      {
        path: 'weakest-link',
        /* internal name: '/movies/weakest-link' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'MoviesWeakestLinkPage',
            component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/movies/weakest-link/[id].vue'),
            /* no children */
          },
  _definePage_default_12
  )
        ],
      }
    ],
  },
  {
    path: '/music',
    /* internal name: '/music' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'MusicPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/index.vue'),
        /* no children */
      },
  _definePage_default_13
  ),
  _mergeRouteRecord(
      {
        path: 'beat-the-clock',
        name: 'MusicBeatTheClockPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/beat-the-clock.vue'),
        /* no children */
      },
  _definePage_default_14
  ),
  _mergeRouteRecord(
      {
        path: 'classic-game',
        name: 'MusicClassicGamePage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/classic-game.vue'),
        /* no children */
      },
  _definePage_default_15
  ),
  _mergeRouteRecord(
      {
        path: 'leaderboard',
        name: 'MusicLeaderboard',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/leaderboard.vue'),
        /* no children */
      },
  _definePage_default_16
  ),
  _mergeRouteRecord(
      {
        path: 'settings',
        name: 'MusicSettingsPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/settings.vue'),
        /* no children */
      },
  _definePage_default_17
  ),
      {
        path: 'weakest-link',
        /* internal name: '/music/weakest-link' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'MusicWeakestLinkPage',
            component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/music/weakest-link/[id].vue'),
            /* no children */
          },
  _definePage_default_18
  )
        ],
      }
    ],
  },
  {
    path: '/people',
    /* internal name: '/people' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'PeoplePage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/index.vue'),
        /* no children */
      },
  _definePage_default_19
  ),
  _mergeRouteRecord(
      {
        path: 'beat-the-clock',
        name: 'PeopleBeatTheClockPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/beat-the-clock.vue'),
        /* no children */
      },
  _definePage_default_20
  ),
  _mergeRouteRecord(
      {
        path: 'classic-game',
        name: 'PeopleClassicGamePage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/classic-game.vue'),
        /* no children */
      },
  _definePage_default_21
  ),
  _mergeRouteRecord(
      {
        path: 'leaderboard',
        name: 'PeopleLeaderboard',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/leaderboard.vue'),
        /* no children */
      },
  _definePage_default_22
  ),
  _mergeRouteRecord(
      {
        path: 'settings',
        name: 'PeopleSettingsPage',
        component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/settings.vue'),
        /* no children */
      },
  _definePage_default_23
  ),
      {
        path: 'weakest-link',
        /* internal name: '/people/weakest-link' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'PeopleWeakestLinkPage',
            component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/people/weakest-link/[id].vue'),
            /* no children */
          },
  _definePage_default_24
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicyPage',
    component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/privacy-policy.vue'),
    /* no children */
  },
  _definePage_default_25
  ),
  _mergeRouteRecord(
  {
    path: '/terms-of-use',
    name: 'TermsOfUsePage',
    component: () => import('/home/user/Desktop/The_Older_One/higher-or-lower/src/pages/terms-of-use.vue'),
    /* no children */
  },
  _definePage_default_26
  )
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

